import { Button, FormControl, FormLabel, Input, Modal, ModalClose, ModalDialog, ModalOverflow, Stack, Typography, Checkbox, Select, Option } from "@mui/joy";
import { useContext, useState } from "react";
import { LayoutContext } from "../../context";
import { motion, AnimatePresence } from "framer-motion";
import { APICreateEventAdditionalService } from "../../api";



export default function ModalAddEventService() {
    const { modalAddEventService, setModalAddEventService } = useContext(LayoutContext);
    
    const [title, setTitle] = useState("");
    const [surveyorPrice, setSurveyorPrice] = useState(0);
    const [draftsmanPrice, setDraftsmanPrice] = useState(0);
    const [isFullPriceVolume, setIsFullPriceVolume] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const [calculationType, setCalculationType] = useState('per_sqm');
    const [inputLabel, setInputLabel] = useState('');
    const [inputUnit, setInputUnit] = useState('');
    const [percentBase, setPercentBase] = useState('base_surveyor');

    function generateRandomString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    const handleCreate = async () => {
        if (!title) {
            alert("Введите название услуги");
            return;
        }
        
        setLoading(true);
        
        if (!modalAddEventService.eventId) {
            const newService = {
                token: `custom-${generateRandomString(5)}`,
                id: Date.now(),
                title: title,
                custom_title: title,
                custom_surveyor_price: Number(surveyorPrice),
                custom_draftsman_price: Number(draftsmanPrice),
                full_price_volume: isFullPriceVolume,
                // ── НОВОЕ ──
                calculation_type: calculationType,
                input_label: calculationType === 'per_input' ? inputLabel : null,
                input_unit: calculationType === 'per_input' ? inputUnit : null,
                percent_base: calculationType === 'percent' ? percentBase : null,
                input_value: null, // заполнит чертёжник при сдаче
                // ────────────
                additional_service: null,
                isCustom: true
            };
            modalAddEventService.onSave(newService);
            setModalAddEventService({ open: false });
        }
        else {
            try {
                const serviceData = {
                    event: modalAddEventService.eventId,
                    custom_title: title,
                    custom_surveyor_price: Number(surveyorPrice),
                    custom_draftsman_price: Number(draftsmanPrice),
                    full_price_volume: isFullPriceVolume,
                    // ── НОВОЕ ──
                    calculation_type: calculationType,
                    input_label: calculationType === 'per_input' ? inputLabel : null,
                    input_unit: calculationType === 'per_input' ? inputUnit : null,
                    percent_base: calculationType === 'percent' ? percentBase : null,
                };
                
                const response = await APICreateEventAdditionalService(serviceData);
                
                if (response.status === 'ok') {
                    const newService = {
                        token: `custom-${response.service_item.id}`,
                        isCustom: true,
                        idService: null,
                        idItem: response.service_item.id,
                        title: response.service_item.custom_title,
                        custom_surveyor_price: Number(response.service_item.custom_surveyor_price),
                        custom_draftsman_price: Number(response.service_item.custom_draftsman_price),
                        full_price_volume: response.service_item.full_price_volume,
                        calculation_type: response.service_item.calculation_type,
                        input_label: response.service_item.input_label,
                        input_unit: response.service_item.input_unit,
                        percent_base: response.service_item.percent_base,
                        input_value: response.service_item.input_value,
                    };
                    
                    // Передаем созданную услугу в callback
                    modalAddEventService.onSave(newService);
                    
                    // Очищаем форму и закрываем модальное окно
                    setTitle("");
                    setSurveyorPrice(0);
                    setDraftsmanPrice(0);
                    setIsFullPriceVolume(false);
                    setCalculationType('per_sqm');
                    setInputLabel('');
                    setInputUnit('');
                    setPercentBase('base_surveyor');
                    setModalAddEventService({ open: false });
                } else {
                    alert('Ошибка при создании услуги: ' + (response.message || 'Неизвестная ошибка'));
                }
            } catch (error) {
                console.error('Ошибка создания услуги:', error);
                alert('Ошибка при создании услуги');
            }
        }
        setLoading(false);
    };

    // Функция очистки формы при закрытии
    const handleClose = () => {
        setTitle("");
        setSurveyorPrice(0);
        setDraftsmanPrice(0);
        setIsFullPriceVolume(false);
        setCalculationType('per_sqm');
        setInputLabel('');
        setInputUnit('');
        setPercentBase('base_surveyor');
        setLoading(false);
        setModalAddEventService({ open: false });
    };

    return (
        <AnimatePresence>
            {modalAddEventService.open && (
                <Modal
                    sx={{ zIndex: 10103 }}
                    open={modalAddEventService.open}
                    onClose={() => setModalAddEventService({ open: false })}
                    slotProps={{
                        backdrop: {
                            component: motion.div,
                            initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                            animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                            exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                            transition: { duration: 0.3, ease: "easeInOut" },
                        }
                    }}
                >
                    <ModalOverflow>
                        <ModalDialog
                            size="lg"
                            component={motion.div}
                            initial={{ opacity: 0, y: -10, scale: 0.98 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 10, scale: 0.98 }}
                            transition={{ duration: 0.2, ease: "easeInOut" }}
                            sx={{ width: '400px' }}
                        >
                            <ModalClose />
                            <Typography level="h4">Добавить услугу</Typography>
                            <Stack spacing={2} sx={{ mt: 2 }}>
                                <FormControl>
                                    <FormLabel>Название услуги*</FormLabel>
                                    <Input value={title} onChange={(e) => setTitle(e.target.value)} required />
                                </FormControl>

                                {/* ── тип расчёта ── */}
                                <FormControl>
                                    <FormLabel>Тип расчёта</FormLabel>
                                    <Select
                                        value={calculationType}
                                        onChange={(_, v) => setCalculationType(v)}
                                        slotProps={{ listbox: { sx: { zIndex: 10104 } } }}
                                    >
                                        <Option value="per_sqm">За м² от площади события</Option>
                                        <Option value="fixed">Фиксированная сумма</Option>
                                        <Option value="percent">Процент от базовой ЗП</Option>
                                        <Option value="per_input">За единицу пользовательского ввода</Option>
                                    </Select>
                                </FormControl>

                                <FormControl>
                                    <FormLabel>{
                                        calculationType === 'fixed'     ? 'Стоимость для обмерщика (₽)' :
                                        calculationType === 'percent'   ? 'Процент (Обмерщику), %' :
                                        calculationType === 'per_input' ? `Стоимость за ${inputUnit || 'единицу'} (Обмерщику)` :
                                                                        'Стоимость для обмерщика (₽/м²)'
                                    }</FormLabel>
                                    <Input
                                        type="number"
                                        value={surveyorPrice}
                                        onChange={(e) => setSurveyorPrice(e.target.value)}
                                        required
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>{
                                        calculationType === 'fixed'     ? 'Стоимость для чертежника (₽)' :
                                        calculationType === 'percent'   ? 'Процент (Чертежнику), %' :
                                        calculationType === 'per_input' ? `Стоимость за ${inputUnit || 'единицу'} (Чертежнику)` :
                                                                        'Стоимость для чертежника (₽/м²)'
                                    }</FormLabel>
                                    <Input
                                        type="number"
                                        value={draftsmanPrice}
                                        onChange={(e) => setDraftsmanPrice(e.target.value)}
                                        required
                                    />
                                </FormControl>

                                {/* ── Поля только для per_input ── */}
                                {calculationType === 'per_input' && (
                                    <>
                                        <FormControl>
                                            <FormLabel>Название поля ввода</FormLabel>
                                            <Input
                                                value={inputLabel}
                                                onChange={(e) => setInputLabel(e.target.value)}
                                                placeholder="Например: Длина периметра"
                                                required
                                            />
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Единица измерения</FormLabel>
                                            <Input
                                                value={inputUnit}
                                                onChange={(e) => setInputUnit(e.target.value)}
                                                placeholder="м.п. / м² / шт"
                                                required
                                            />
                                        </FormControl>
                                    </>
                                )}

                                {/* ── Поле только для percent ── */}
                                {calculationType === 'percent' && (
                                    <FormControl>
                                        <FormLabel>База для процента</FormLabel>
                                        <Select
                                            value={percentBase}
                                            onChange={(_, v) => setPercentBase(v)}
                                            slotProps={{ listbox: { sx: { zIndex: 10104 } } }}
                                        >
                                            <Option value="base_surveyor">От базы обмерщика (без допов)</Option>
                                            <Option value="base_draftsman">От базы чертёжника (без допов)</Option>
                                            <Option value="total_surveyor">От итога обмерщика (с допами)</Option>
                                            <Option value="total_draftsman">От итога чертёжника (с допами)</Option>
                                        </Select>
                                    </FormControl>
                                )}

                                {/* ── Чекбокс «фикс» оставляем как deprecated, можно удалить позже ──
                                    Чтобы не сломать UX для существующих процессов — пока не убираем,
                                    но он становится дублирующим: то же самое можно выбрать через тип «fixed».
                                    Можно показывать только при calculationType === 'per_sqm' для совместимости
                                    или вообще скрыть. Я бы скрыл: */}
                                {/* (старый блок «Checkbox isFullPriceVolume» удаляем) */}

                                <Button loading={loading} onClick={handleCreate}>
                                    Добавить
                                </Button>
                            </Stack>
                        </ModalDialog>
                    </ModalOverflow>
                </Modal>
            )}
        </AnimatePresence>
    );
}